<template>
  <v-btn
    v-if="submit"
    type="submit"
    :color="color"
    :text="text"
    :ripple="ripple"
    :class="classObject"
    :disabled="disabled"
    :loading="loading"
    class="brazil-btn"
    @click="clicked"
  >
    <slot />
  </v-btn>
  <v-btn
    v-else
    :color="color"
    :text="text"
    :ripple="ripple"
    :class="classObject"
    :disabled="disabled"
    :loading="loading"
    :depressed="depressed"
    class="brazil-btn"
    @click="clicked"
  >
    <slot />
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib';

export default {
  name:       'BrazilVBtn',
  components: { VBtn },
  props:      {
    text: {
      type:    Boolean,
      default: false,
    },
    ripple: {
      type:    Boolean,
      default: false,
    },
    type: {
      type:    String,
      default: 'primary',
    },
    disabled: {
      type:    Boolean,
      default: false,
    },
    loading: {
      type:    Boolean,
      default: false,
    },
    submit: {
      type:    Boolean,
      default: false,
    },
    depressed: {
      type:    Boolean,
      default: false,
    },
  },
  computed: {
    color() {
      switch (this.type) {
        case 'action':
          return '#ffc538';
        case 'normal':
          return 'normal';
        default:
          return 'primary';
      }
    },
    classObject() {
      switch (this.type) {
        case 'action':
          return 'white-text';
        default:
          return '';
      }
    },
  },
  methods: {
    clicked(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped>
  .brazil-btn.v-btn {
    letter-spacing: 0;
    font-weight: bold;
    margin-top: 6px;
    width: 100%;
    font-size: 1em;
  }
  .brazil-btn.v-btn.white-text {
    color: #ffffff;
  }
</style>
